import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Icon } from "../../../Icon";
import CartSizeTooltip from "./CartSizeTooltip";
import CartModal from "../../../CartModal";
import useOnClickOutside from "../../../../utils/hooks/useOnClickOutside";
import { useCart } from "../../../../context/CartContext";
import { clearAllBodyScrollLocks } from "body-scroll-lock";

type Props = {};
const CartSection: FunctionComponent<Props> = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<
    "productAdded" | "AllProductsAdded"
  >("AllProductsAdded");
  const { isLoading, lastProductAdded } = useCart();

  useEffect(() => {
    if (lastProductAdded) {
      setIsOpen(true);
      setModalType("productAdded");
    }
  }, [lastProductAdded]);

  const toggleModal = () => {
    if (isOpen) setModalType("AllProductsAdded");
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    clearAllBodyScrollLocks();
    setIsOpen(false);
    setModalType("AllProductsAdded");
  };

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => {
    setIsOpen(false);
    setModalType("AllProductsAdded");
  });
  return (
    <div className="cart-section" ref={ref}>
      <div className="cart-section__icon" onClick={toggleModal}>
        <Icon iconName="shopping_bag" />
      </div>
      <CartSizeTooltip />
      {isOpen && (
        <CartModal
          handleClose={handleClose}
          type={modalType}
          productLoading={isLoading}
        />
      )}
    </div>
  );
};
export default CartSection;
